import { isNetworkError } from './ApiError';
interface ApiError {
	request: XMLHttpRequest;
	response?: Response;
	message: string;
	stack: string;
}

interface Response {
	status: number;
	statusText: string;
	data: any;
	config: any;
	headers: any;
	request: XMLHttpRequest;
}

export function catchError(e: ApiError) {
	console.log({ e });
	if (e.response?.data?.displayableError) {
		// @ts-ignore
		MeddiApp.notification(e.response.data.message);
		// @ts-ignore
	} else if (isNetworkError(e)) {
		// Display error message when user is not connected to the internet
		// @ts-ignore
		MeddiApp.notification(jsTranslation['base.shared.notConnected']);
		// @ts-ignore
	} else if (e.code !== 'ECONNABORTED') {
		// @ts-ignore
		MeddiApp.notification(jsTranslation['base.shared.warningBug']);
	}

	return {
		data: { ...e.response?.data, error: true },
		status: e.response?.status,
		statusText: e.response?.statusText,
	};
}
